export default "__VITE_ASSET__JG6Y5Alv__ 350w";